import type { WritableSignal } from '@angular/core';
import { Injectable, signal } from '@angular/core';

import { ENGLISH_LANGUAGE_CODE } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private readonly localeId = signal<string>(ENGLISH_LANGUAGE_CODE);

  setLocale(lang: string) {
    this.localeId.set(lang);
  }

  getLocale(): string {
    return this.localeId();
  }

  getLocaleSignal(): WritableSignal<string> {
    return this.localeId;
  }
}
